import { Button, Select, Switch, Input, Tooltip } from "antd";
import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../atoms/CustomIcons";
import React, { useState } from "react";
import { useAppSelector } from "../../../../config/hooks";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      type: undefined | string;
      status: undefined | string[];
      state: undefined;
      city: undefined;
      onboarding_complete_date: string[] | undefined;
      last_user_activity: string[] | undefined;
      search_text: undefined | string;
    }>
  >;
  filters: {
    type: undefined | string;
    status: undefined | string[];
    state: undefined;
    city: undefined;
    onboarding_complete_date: string[] | undefined;
    last_user_activity: string[] | undefined;
    search_text: undefined | string;
  };
  archived: boolean;
  isArchived: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Filters(props: FilterProps) {
  const { setFilters, filters, archived, isArchived } = props;
  const [showFilters, setShowFilters] = useState(false);
  const clientManagerList = useAppSelector(
    (state) => state?.company?.companyClientManager
  );

  const onChange = (checked: boolean) => {
    isArchived(checked);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: ["archived"],
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: undefined,
      }));
    }
  };

  const clearFilters = () => {
    setFilters({
      type: undefined,
      status: undefined,
      state: undefined,
      city: undefined,
      onboarding_complete_date: undefined,
      last_user_activity: undefined,
      search_text: undefined,
    });
    isArchived(false);
  };

  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search properties"
            value={filters?.search_text}
            allowClear
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                search_text: e.target.value,
              }))
            }
          />
        </div>
        <div className="filterToggle">
          <Button
            icon={<FilterIcon />}
            className={`outlined-btn ${showFilters && "show_filters"} ${
              archived && "archived"
            }`}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters{" "}
            <div className="filter_icon">
              <SelectArrow />
            </div>
          </Button>
        </div>
        <div className="filterDownload">
          <Tooltip title="Export the list of services">
            <Button icon={<DownloadIcon />} />
          </Tooltip>
        </div>
        <div className="filterBox">
          <Tooltip title="Show properties assigned to me">
            <div className="switchBox">
              <Switch />
              Mine only
            </div>
          </Tooltip>
        </div>
      </div>
      {showFilters && (
        <div className="filtersBottom">
          <div className="btmLeft">
            <div className="filterBox">
              <Tooltip title="Categories" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, type: value }))
                  }
                  value={filters?.type}
                  placeholder="Categories"
                  options={[
                    {
                      value: "company",
                      label: "Company",
                    },
                    {
                      value: "individual",
                      label: "Individual",
                    },
                  ]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Service lines" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Service lines"
                  options={[]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Responsible for account" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Responsible for account"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Production manager" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Production manager"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Contact status" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Contact status"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Earned revenue (R12M)" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Earned revenue (R12M)"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Gross margin (R12M)" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Gross margin (R12M)"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="City" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="City"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="State" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "216px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="State"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onChange} checked={archived} />
                {archived ? "Hide archived" : "Show archived"}
              </div>
            </div>
          </div>

          <div className="btmRight">
            <Button
              className="outlined-btn"
              onClick={clearFilters}
              disabled={!filters.type && !filters.status}
            >
              Clear filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
